module.exports = __webpack_public_path__ + "img/escalier_marche_3.c8ec15cf.svg";